

import { ref } from "vue";
import { defineComponent } from 'vue';
import moment from 'moment';

import ArgonButton from "@/components/ArgonButton.vue";

export default defineComponent({
  name: "pedidos-table",
  components: {
    ArgonButton
  },
    props: {
      pedidos: {
        type: Array,
        default: () => {
          [];
        },
      },
      doUpdate: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      doAddTag: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      doRemoveTag: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      doRemovePedido: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      searchCall: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
    },
    data() {
      return {
        por_pagina : false,
        isLast: false,
        sortKey: '', // Chave de ordenação
        sortAsc: true, // Direção da ordenação
        searchItem: false,
        searchItemTime: false,
        searchIKey: '',
        searchQuery:'',
        searchQueryTime:'',
      }
    },
    computed: {
      sortedData(){
        return this.pedidos.slice().sort((a:any, b:any) => {
          if (this.sortKey) {
            const keyA = a[this.sortKey];
            const keyB = b[this.sortKey];
            if (this.sortAsc) {
              return keyA < keyB ? -1 : keyA > keyB ? 1 : 0;
            } else {
              return keyA > keyB ? -1 : keyA < keyB ? 1 : 0;
            }
          }
          return 0;
        });
      },
    },
    methods: {

      gotoPedido(pedido:any){
        this.$router.push(`/pedidos/${pedido.id_pedido}`);
      },
      iconSort(key:any){
        if(this.sortKey != key)return `<i  class="fas fa-arrow-fas fa-arrow-down"></i>`
        return `<i  class="fas fa-arrow-${this.sortAsc ? 'fas fa-arrow-up' : 'fas fa-arrow-down'}"></i>`

      },
      searchData(key:any) {
        if (this.searchIKey === key) {
          this.searchItem = !this.searchItem; // Alterna a direção da ordenação
        } else {
          this.searchIKey = key;
          this.searchItem = true; // Se mudar a chave, a ordenação será ascendente por padrão
        } 
      },  
      searchTime(key:any) {
        if (this.searchIKey === key) {
          this.searchItemTime = !this.searchItemTime; // Alterna a direção da ordenação
        } else {
          this.searchIKey = key;
          this.searchItemTime = true; // Se mudar a chave, a ordenação será ascendente por padrão
        } 
      },  
      sortData(key:any) {
        if (this.sortKey === key) {
          this.sortAsc = !this.sortAsc; // Alterna a direção da ordenação
        } else {
          this.sortKey = key;
          this.sortAsc = true; // Se mudar a chave, a ordenação será ascendente por padrão
        }
      },

    },
    setup(props:any) {
      
      const addTag = (pedido:any) => {

        pedido.capacidade++;

        pedido.editingcapacidade=true
       
        if(!pedido.embalagens)pedido.embalagens = [];
        if (pedido.textTag.trim() !== "" && !pedido.embalagens.includes(pedido.textTag)) {
          
          
          props.doAddTag(pedido, pedido.textTag); // Define o novo cen tro do mapa
          pedido.textTag = ""; // Limpa o campo após adicionar

        }
      };

      const removeTag = (pedido:any, id_embalagem:any) => {
        
        pedido.capacidade--;
        pedido.editingcapacidade=true
        
        props.doRemoveTag(pedido, id_embalagem); // Define o novo cen tro do mapa
      }

      const removePedido = (pedido:any, id_embalagem:any) => {
        props.doRemovePedido(pedido, id_embalagem); // Define o novo cen tro do mapa
      }

      const doUpdate = (capacidade: any, pedido: any) => {

          //console.log(capacidade, pedido)
          pedido.editingcapacidade=false
          props.doUpdate(capacidade, pedido); // Define o novo cen tro do mapa
      };

      const doAddTag = (capacidade: any, pedido: any) => {
          props.doAddTag(capacidade, pedido); // Define o novo cen tro do mapa
      };

      const searchCall = (field:any, termo:any) => {
        props.searchCall(field, termo); // Define o novo cen tro do mapa
      };


      const fDate = (date:any) => {
        return moment(date).format('DD/MM/YYYY HH:mm:ss');
      }


      const editJanela = (pedido:any, campo:any) => {
       
        if (campo === 'inicio'){

          pedido.janela_entrega_inicio = moment(pedido.janela_entrega_inicio).utc();
          pedido.janela_entrega_fim = moment(pedido.janela_entrega_inicio).add(2, 'hours');
          
          pedido.editInicio = false;

        }

        if (campo === 'fim'){
        pedido.janela_entrega_fim = moment(pedido.janela_entrega_fim).utc();
          pedido.editFim = false;
        } 

        pedido.manual = true;
        props.doUpdate({}, pedido); // Define o novo cen tro do mapa

      };

      const CanceleditJanela = (pedido:any, campo:any) => {

        if (campo === 'inicio') pedido.editInicio = false;
        if (campo === 'fim') pedido.editFim = false;

      };

      // Retorna os métodos ou variáveis que você quer expor
      return {
        //newTag,
        removeTag,
        removePedido,
        addTag,
        doUpdate,
        searchCall,
        fDate,
        CanceleditJanela,
        editJanela
      };
    },

});
